const igCustomIntervalChange = setInterval(function () {
    
	const cartDiv = document.querySelector('#slidecarthq .slidecarthq');
  
    if (cartDiv) {
        const cartHeader = cartDiv.querySelector('.header');
        const spb = document.createElement("ig-shipping-progress-container");
        cartDiv.insertBefore(spb,cartHeader.nextSibling);
        clearInterval(igCustomIntervalChange)
    }
}, 500)